module.exports = __webpack_public_path__ + "img/firmaCotizacion.ed24e0b4.png";